import { render, staticRenderFns } from "./SSkeletonTable.vue?vue&type=template&id=00ed9209&scoped=true"
import script from "./sSkeletonTable.ts?vue&type=script&lang=ts&external"
export * from "./sSkeletonTable.ts?vue&type=script&lang=ts&external"
import style0 from "./SSkeletonTable.vue?vue&type=style&index=0&id=00ed9209&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ed9209",
  null
  
)

export default component.exports